import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';

interface SessionStatus {
  success: boolean;
  status?: string;
  payment_status?: string;
  clientSecret?: string;
}

export default function CheckoutCancel() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [status, setStatus] = useState<string>('');
  const [clientSecret, setClientSecret] = useState<string>('');

  useEffect(() => {
    const run = async () => {
      if (!sessionId) return;
      try {
        const res = await fetch(`/api/checkout/session-status/${sessionId}`);
        const data: SessionStatus = await res.json();
        setStatus(`${data.status || 'unknown'} / ${data.payment_status || 'unpaid'}`);
        if (data.clientSecret) setClientSecret(data.clientSecret);
      } catch {}
    };
    run();
  }, [sessionId]);

  return (
    <div className="container mx-auto px-4 py-12 text-center">
      <h1 className="text-3xl font-bold text-white mb-4">Payment was not completed</h1>
      {status && <p className="text-gray-300 mb-6">Status: {status}</p>}
      {sessionId && (
        <Link className="inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold px-6 py-3" to={`/checkout/pay?session_id=${sessionId}`}>
          Try again
        </Link>
      )}
    </div>
  );
}


